import { render, staticRenderFns } from "./CommsPayoutDetails.vue?vue&type=template&id=20c0e647"
import script from "./CommsPayoutDetails.vue?vue&type=script&lang=js"
export * from "./CommsPayoutDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports